import SubmitButton from './SubmitButton'
export { type BaseSubmitButtonProps, default as BaseSubmitButton } from './BaseSubmitButton'
export default SubmitButton
